export default __webpack_public_path__ + "static/media/arrow-sm-down.5ee2ed3d.svg";